import { render } from "./KioskReciept.vue?vue&type=template&id=f007cb2e&scoped=true"
import script from "./KioskReciept.vue?vue&type=script&lang=js"
export * from "./KioskReciept.vue?vue&type=script&lang=js"

import "./KioskReciept.vue?vue&type=style&index=0&id=f007cb2e&scoped=true&lang=css"

import exportComponent from "/home/scotty/git/beamy/monolith/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f007cb2e"]])

export default __exports__